<template>
    <section class="container-fluid" id="parent">
        <h1 class="page-heading">General Payments</h1>

        <div class="mb-3">
            <div class="row">
                <div class="col-cm-12">
                    <div class="btn-group mb-3" role="group">
                        <button type="button" 
                                :class="['btn', store.currentPage == 'INVOICE' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('INVOICE')">
                            Invoice
                        </button>
                        <button type="button" 
                                :class="['btn', store.currentPage == 'PAYMENT' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('PAYMENT')"
                                :disabled="store.progressPage < 1">
                            Payment
                        </button>
                        <button type="button" 
                                :class="['btn', store.currentPage == 'REVIEW' ? 'btn-outline-primary' : 'btn-primary']" @click="goBackToPage('REVIEW')"
                                :disabled="store.progressPage < 2">
                            Review
                        </button>
                        <button type="button" 
                                :class="['btn', store.currentPage == 'FINISH' ? 'btn-outline-primary' : 'btn-primary']"
                                :disabled="store.progressPage < 3">
                            Finish
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Invoice v-show="store.currentPage == 'INVOICE'" @goToPage="goToPage"></Invoice>
        <Payment v-show="store.currentPage == 'PAYMENT'" @goToPage="goToPage"></Payment>
        <Review v-show="store.currentPage == 'REVIEW'" @goToPage="goToPage" @goBackToPage="goBackToPage"></Review>
        <Finish v-show="store.currentPage == 'FINISH'"></Finish>
    </section>
</template>

<script setup>
    import { useStore } from './store';
    import Invoice from './invoice';
    import Payment from './payment';
    import Review from './review';
    import Finish from './finish';

    const store = useStore();

    function goToPage(page) {

        store.currentPage = page;

        if (page == 'PAYMENT' && store.progressPage < 1)
            store.progressPage = 1;

        if (page == 'REVIEW' && store.progressPage < 2)
            store.progressPage = 2;
    }

    function goBackToPage(page) {
        store.currentPage = page;
    }

</script>